import { type FC } from "react";
import { useEditorForm } from "@/features/NoteEditor/model";
import { AppForm } from "@/shared/Components";
import type { NoteEditorProps } from "@/features/NoteEditor/model/types";
import { MobileContent } from "./MobileContent";

export const NoteEditorMobile: FC<NoteEditorProps> = ({
  onSubmit,
  currentNote,
  deleteNoteFileById,
}) => {
  const { formApi } = useEditorForm(currentNote, onSubmit);

  return (
    <AppForm formApi={formApi} onSubmit={onSubmit}>
      <MobileContent deleteNoteFileById={deleteNoteFileById} />
    </AppForm>
  );
};
